<script setup>
import { computed, onBeforeUnmount, onMounted, ref, useTemplateRef } from 'vue';

const props = defineProps({
  showOnScroll: {
    type: Boolean,
    default: false,
  },

  slideUp: {
    type: Boolean,
    default: true,
  },
});

const showContent = ref(false);
const element = useTemplateRef('element');

const showElementsInView = () => {
  if (element.value.offsetTop < window.screen.height) {
    showContent.value = true;
  }
};

const handleScroll = () => {
  const positionTop = element.value.offsetTop + element.value.clientHeight / 2;

  if (positionTop < window.scrollY + window.screen.height) {
    showContent.value = true;
  }
};

const classes = computed(() => ({
  'slide-up': props.slideUp,
  'show-content': showContent.value,
}));

onMounted(() => {
  if (props.showOnScroll) {
    showElementsInView();
    window.addEventListener('scroll', handleScroll);
    return;
  }

  window.setTimeout(() => {
    showContent.value = true;
  }, 10);
});

onBeforeUnmount(() => {
  if (props.showOnScroll) {
    window.removeEventListener('scroll', handleScroll);
  }
});
</script>

<template>
  <div class="fade" :class="classes" ref="element">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.fade {
  transition: transform 0.7s, opacity 0.7s;
  opacity: 0;

  &.slide-up {
    transform: translateY(10px);
  }

  &.show-content {
    opacity: 1;
    transform: unset;
  }
}
</style>
